import type {Editor} from "slate";

import {getCoeditorVariables} from "@khan/guide-coeditor-core";
import {isKhanmigoEditing} from "@khan/guide-math-editor";

// eslint-disable-next-line static-service/require-shared-package-imports-only -- porting from old code
import {TEACHER_KHANMIGO_TOOLS_PATH} from "~/coach-dashboard-package/khanmigo/path-helpers.ts";
// eslint-disable-next-line static-service/require-shared-package-imports-only -- porting from old code.
import {PARENT_KHANMIGO_TOOLS_PATH} from "~/page-package/util.ts";

export default function shouldAutosaveCoeditor(
    threadId: string | null | undefined,
    currentPathname: string,
    editor: Editor | null,
): boolean {
    if (!threadId || !editor) {
        return false;
    }

    const {started} = getCoeditorVariables();
    if (!started) {
        return false;
    }

    if (isKhanmigoEditing(editor)) {
        return false;
    }

    if (
        !currentPathname.includes(TEACHER_KHANMIGO_TOOLS_PATH) &&
        !currentPathname.includes(PARENT_KHANMIGO_TOOLS_PATH)
    ) {
        return false;
    }

    return true;
}
